import { GridCellParams } from '@/components/custom/erp';
import React, { useMemo } from 'react';
import { InputTable, RepeatRowsPayload } from '@/components/custom/erp';
import { SelectedTaxCellInfo } from '../hooks/useTaxRows';
import { copyCellValue } from '@/lib/table-handlers';
import { useTaxPaste } from '../hooks/useTaxPaste';
import { getTaxTableColumns } from './columns';
import { FormMode } from '@/types/form';
import ActionBar from './ActionBar';

interface TaxsTabProps {
  formMode: FormMode;
  rows: { uuid?: string | null }[];
  selectedRowUuid?: string | null;
  selectedCell?: SelectedTaxCellInfo | null;
  onRowClick?: (params: any) => void;
  onCellClick?: (params: GridCellParams) => void;
  onAddRow: () => void;
  onDeleteRow: () => void;
  onCopyRow: () => void;
  onPasteRow: (clipboardText?: string) => void | Promise<void>;
  onMoveRow: (direction: 'up' | 'down') => void;
  onRepeatForRows: (payload: RepeatRowsPayload<any>) => void;
  onCellValueChange: (rowUuid: string, field: string, newValue: any) => void;
  handleUpdateNonWritableFields?: (fields: Set<string>) => void;
  handleUpdatePasteConfigs?: (
    configs: Record<string, { resolver: (codes: string[]) => Promise<any[]>; resultField?: string }>
  ) => void;
}

export const TaxsTab: React.FC<TaxsTabProps> = ({
  formMode,
  rows,
  selectedRowUuid,
  selectedCell,
  onRowClick,
  onCellClick,
  onAddRow,
  onDeleteRow,
  onCopyRow,
  onPasteRow,
  onMoveRow,
  onRepeatForRows,
  onCellValueChange,
  handleUpdateNonWritableFields,
  handleUpdatePasteConfigs
}) => {
  const columns = useMemo(
    () => getTaxTableColumns(formMode, onCellValueChange) as any[],
    [formMode, onCellValueChange]
  );

  useTaxPaste({
    columns,
    handleUpdateNonWritableFields,
    handleUpdatePasteConfigs
  });

  return (
    <InputTable
      rows={rows}
      autoHeight
      bottomSelector='[data-arito-bottom-bar]'
      onRowClick={onRowClick}
      onCellClick={onCellClick}
      selectedRowId={selectedRowUuid || undefined}
      columns={columns}
      getRowId={row => row?.uuid || ''}
      enableContextMenu={true}
      onCopyData={({ columnValue, columnField, columnValues }) => {
        copyCellValue({
          columnField,
          columnValue,
          columnValues,
          fallback: text => {
            console.log('Copy data per column:', text);
          }
        });
      }}
      onRepeatForRows={onRepeatForRows}
      actionButtons={
        <ActionBar
          formMode={formMode}
          handleAddRow={onAddRow}
          handleDeleteRow={onDeleteRow}
          handleCopyRow={onCopyRow}
          handlePasteRow={onPasteRow}
          selectedCell={selectedCell}
          handleMoveRow={onMoveRow}
          handleExport={() => console.log('Export clicked')}
          handlePin={() => console.log('Pin clicked')}
        />
      }
    />
  );
};
